import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../lib/CartContext";
import { useLang } from "../lib/LanguageContext";

export const FloatingCart = () => {
  const { totalQty, setOpen } = useCart();
  const { t } = useLang();

  return (
    <AnimatePresence>
      {totalQty > 0 && (
        <motion.button
          type="button"
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          onClick={() => setOpen(true)}
          data-testid="floating-cart"
          className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-3 bg-brand-blue text-white pl-5 pr-6 py-3.5 rounded-full shadow-2xl shadow-brand-blue/30 hover:bg-blue-800 transition-colors"
          aria-label="View cart"
        >
          <span className="relative">
            <ShoppingBag className="w-5 h-5" strokeWidth={1.8} />
            <span className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full bg-brand-gold text-brand-coffee text-[10px] font-bold flex items-center justify-center">
              {totalQty}
            </span>
          </span>
          <span className="text-sm font-medium">{t.cart.view}</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};
